import type { Brand } from "../../types/brand"
import type { LoanOfficer } from "../../types/loan-officer"
import type { UserDetails } from "../../types/user"

export const getBrandName = (
  brandDetails: Brand | undefined,
  loProfile: LoanOfficer | undefined,
  user: UserDetails | undefined
): string => {
  if (brandDetails?.name) return brandDetails.name
  if (loProfile?.bank) return loProfile.bank
  if (user?.brand_id && user?.org?.brands) {
    const brand = user.org.brands.find(b => b.id === user.brand_id)
    if (brand?.name) return brand.name
  }
  return user?.org?.name || ""
}

export const buildApiAccessMailtoLink = (
  fullName: string,
  email: string,
  brandName: string
) =>
  `mailto:support@bankingbridge.com?subject=Requested%20Rateflow%20API%20info&body=name:%20${encodeURIComponent(
    fullName
  )}%0Aemail:%20${encodeURIComponent(email)}%0Abrand:%20${encodeURIComponent(
    brandName
  )}`
